export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12216.0304d2db.jpg";